import { ECampaign } from '../enum/campaign.enum'

const isRedirectCampaigns = (campaign: ECampaign) => {
  const campaigns = [ECampaign.USA, ECampaign.CHATBOT]

  return campaigns.includes(campaign)
}

export default isRedirectCampaigns
